
const presignedUrlsActions = {
    types: {
        SET_PRESIGNED_URL: 'SET_PRESIGNED_URL',
    },
    setPresignedUrl(identifier, presignedUrl, timestamp = Date.now()) {
        return { type: this.types.SET_PRESIGNED_URL, identifier, presignedUrl, timestamp };
    },
};

export default presignedUrlsActions;
